import React from "react";

const Catalogot = () => {
    return (
        <>
            <div style={{ height: "100vh"}}>
                <iframe 
                    src="/PDF/catalogo-trajes-mr.pdf"
                    width="100%"
                    height="100%"
                    style={{ border: "none"}}
                    title="Catálogo de Trajes"
                />
            </div>
        </>
    );
};

export default Catalogot;